import { CompanyContacts } from 'interfaces';

const SALES_INQUIRIES = 'Sales inquiries';
const GENERAL_INQUIRIES = 'General inquiries';
const US_SALES_PHONE = '+1 720 207 2820';
const UK_SALES_PHONE = '+44 203 687 2282';
const UK_GENERAL_PHONE = '+44 203 687 2281';

export const companyContacts: CompanyContacts = {
  cities: [
    {
      country: 'United States',
      title: 'Decatur',
      address1: '160 Clairemont Ave, Suite 200,\nGA 30030',
      imageName: 'offices/decatur.jpg',
      departmentContacts: [
        {
          name: SALES_INQUIRIES,
          phone: US_SALES_PHONE,
        },
      ],
    },
    {
      country: 'United Kingdom',
      title: 'London',
      address1: '3rd floor, 5-8 Dysart St., EC2A 2BX',
      imageName: 'offices/london.jpg',
      departmentContacts: [
        {
          name: GENERAL_INQUIRIES,
          phone: UK_GENERAL_PHONE,
        },
        {
          name: SALES_INQUIRIES,
          phone: UK_SALES_PHONE,
        },
      ],
    },
  ],
  footerContacts: [
    {
      country: 'United States',
      title: 'Decatur',
      address1: '160 Clairemont Ave, Suite 200,',
      address2: 'GA 30030',
      imageName: 'offices/decatur.jpg',
      departmentContacts: [
        {
          name: SALES_INQUIRIES,
          phone: US_SALES_PHONE,
        },
      ],
    },
    {
      country: 'United Kingdom',
      title: 'London',
      address1: '3rd floor, 5-8 Dysart St.,',
      address2: 'London EC2A 2BX',
      imageName: 'offices/london.jpg',
      departmentContacts: [
        {
          name: SALES_INQUIRIES,
          phone: UK_SALES_PHONE,
        },
        {
          name: GENERAL_INQUIRIES,
          phone: UK_GENERAL_PHONE,
        },
      ],
    },
  ],
};
